import { guestLinks } from '@map/components/GuestArea/links';
import { makeStyles } from '@map/theme';
import { Typography } from '@mui/material';
import useViewportMatch from '@shared/hooks/useViewportMatch';
import Link from '@ui/Link';
import NavButton from '@ui/NavButton';
import { ComponentProps, memo } from 'react';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles(({ spacing }) => ({
  root: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
  },
  button: {
    marginTop: spacing(3.5),
  },
}));

type Props = {
  to: 'login' | 'register';
  variant?: 'contained' | 'outlined' | 'minimal';
  className?: string;
  TypographyProps?: ComponentProps<typeof Typography>;
};

const LoginRegisterTransferLink = ({
  to: toName,
  className,
  variant = 'contained',
  TypographyProps,
}: Props) => {
  const { classes, cx } = useStyles();
  const isDesktop = useViewportMatch('md');
  const isOutlined = isDesktop || variant === 'outlined';
  const isMinimal = variant === 'minimal';
  const label =
    toName === 'login' ? (
      <FormattedMessage id="registration.login_link" />
    ) : (
      <FormattedMessage id="login.signup_link" />
    );
  const to = toName === 'login' ? guestLinks.authentication() : guestLinks.register();

  return (
    <div className={cx(classes.root, className)}>
      <Typography variant="body2" {...TypographyProps}>
        {toName === 'login' ? (
          <FormattedMessage id="registration.already_got_an_account" />
        ) : (
          <FormattedMessage id="login.signup_prompt" />
        )}
        &nbsp;
        {isMinimal && (
          <Link color="inherit" fontWeight="bold" to={to}>
            {label}
          </Link>
        )}
      </Typography>
      {!isMinimal && (
        <NavButton
          fullWidth={true}
          inverse={!isOutlined}
          variant={isOutlined ? 'secondary' : 'primary'}
          size="medium"
          className={classes.button}
          to={to}
        >
          {label}
        </NavButton>
      )}
    </div>
  );
};

export default memo(LoginRegisterTransferLink);
